"use strict";
function getTrackingUrl(order) {
    switch (order.transportProvider) {
        case 'POSTNORD':
            return `https://tracking.postnord.com/se/?id=${order.trackingCode}`;
        case 'BUDCOMPANIETT':
            return `http://api.budcompaniett.se/k2/tt?keyword=${order.trackingCode}`;
        case 'DSV':
            return `https://mydsv.com/new/tracking/track-shipment?query=${order.trackingCode}`;
        default:
            return '';
    }
}
module.exports = {
    getTrackingUrl,
};
